<template>
  <div style="min-width: 90%">
    <h1 class="grey--text text--darken-2">Поддержка</h1>

    <p class="mt-5">Для сообщения о проблемах или пожеланиях разработчикам выберите тему запроса и максимально подробно опишите ситуацию</p>
    <p></p>

    <form>
      <v-select
        v-model="form.subject"
        :items="subjects"
        hide-details
        label="Тема запроса"
        :error-messages="verrSubject"
        rounded
        outlined/>

      <v-textarea
        v-model.trim="form.message"
        hide-details
        label="Сообщение"
        :error-messages="verrMessage"
        rows="12"
        rounded
        outlined
        class="mt-5"></v-textarea>

      <v-file-input
        v-model="files"
        small-chips
        multiple
        label="Прикрепленные файлы"
        class="mt-5"/>

      <v-btn
        raised
        color="primary"
        :loading="loading"
        :disabled="$v.$invalid"
        @click="submitAction"
        class="mt-2">Отправить</v-btn>
    </form>

  </div>
</template>

<script type="text/javascript">
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  mixins: [ validationMixin ],
  validations: {
    form: {
      subject: { required },
      message: { required }
    }
  },
  data: () => ({
    loading: false,
    form: {},
    files: [],
    subjects: [
      {
        text: 'Ошибка (Bug)',
        value: 'bug',
      },
      {
        text: 'Улучшение (Enhancement)',
        value: 'enhancement',
      },
      {
        text: 'Вопрос (Question)',
        value: 'question',
      },
    ],
  }),
  computed: {
    verrSubject () {
      return !this.$v.form.subject.required ? 'Выберите тему' : []
    },
    verrMessage () {
      return !this.$v.form.message.required ? 'Введите текст' : []
    }
  },
  methods: {
    submitAction () {
      if ( this.$v.$invalid ) return
      let formdata = new FormData()
      formdata.append('subject', this.form.subject)
      formdata.append('message', this.form.message)
      for (let file of this.files) {
        formdata.append('files[]', file, file.name);
      }
      this.loading = true
      api.post('support/submit', formdata).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.$root.$alert('Запрос отправлен. Номер вашей заявки '+response.data.data.ticketID)
        this.form = {}
        this.files = []
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
